/**
 * Canto inferior direito (da direita para a esquerda):
 * [FAB chat equipe] — [FAB Central de suporte] — [chips/janelas do chat em equipe →]
 */

export const DOCK_TEAM_FAB_RIGHT = 16;
export const DOCK_TEAM_FAB_SIZE = 52;
export const DOCK_GAP_BETWEEN_FABS = 12;

/** Pílula "SUPORTE": largura fixa para os cards do chat em equipe saberem onde começar. */
export const ASSISTANT_PILL_WIDTH = 124;
export const ASSISTANT_PILL_HEIGHT = 40;
/** Centraliza a pílula na mesma linha do FAB da equipe (bottom 16 + 52/2). */
export const ASSISTANT_PILL_BOTTOM = 16 + (DOCK_TEAM_FAB_SIZE - ASSISTANT_PILL_HEIGHT) / 2;
export const DOCK_GAP_ASSISTANT_TO_TEAM_CARDS = 12;

/** `right` CSS do FAB da Central de suporte (entre o FAB da equipe e os cards). */
export const DOCK_ASSISTANT_FAB_RIGHT =
  DOCK_TEAM_FAB_RIGHT + DOCK_TEAM_FAB_SIZE + DOCK_GAP_BETWEEN_FABS;

/** `right` CSS da borda direita dos chips/janelas do chat em equipe (à esquerda do FAB da IA). */
export const DOCK_TEAM_CHAT_CARDS_RIGHT =
  DOCK_ASSISTANT_FAB_RIGHT + ASSISTANT_PILL_WIDTH + DOCK_GAP_ASSISTANT_TO_TEAM_CARDS;

/** Base inferior dos FABs (suporte + chat equipe) — ver TeamChatDock / VirtualAssistantWidget. */
export const DOCK_ROW_BOTTOM_OFFSET = 16;
/** Folga acima do dock para modais clínicos (nominal; desktop usa --dock-bottom-clearance). */
export const DOCK_BOTTOM_CLEARANCE_PX =
  DOCK_ROW_BOTTOM_OFFSET + DOCK_TEAM_FAB_SIZE + 10;

/** Tokens CSS responsivos (definidos em index.css @media min-width 960px). */
export const DOCK_CSS = {
  fabSize: 'var(--dock-fab-size, 52px)',
  pillWidth: 'var(--dock-pill-width, 124px)',
  pillHeight: 'var(--dock-pill-height, 40px)',
  rowBottom: 'var(--dock-row-bottom, 16px)',
  teamFabRight: 'var(--dock-team-fab-right, 16px)',
  assistantFabRight: 'var(--dock-assistant-fab-right, 80px)',
  teamChatCardsRight: 'var(--dock-team-chat-cards-right, 216px)',
  pillBottom: 'var(--dock-pill-bottom, 22px)',
  bottomClearance: 'var(--dock-bottom-clearance, 78px)',
  horizontalClearance: 'var(--dock-horizontal-clearance, 220px)',
  assistantPanelWidth: 'var(--dock-assistant-panel-width, 440px)',
  assistantPanelHeight: 'var(--dock-assistant-panel-height, 680px)',
} as const;

/** Evita sobrepor paginação MUI ao dock flutuante (Suporte + chat equipe). */
export const tablePaginationClearOfDockSx = {
  '& .MuiTablePagination-toolbar': {
    pr: DOCK_CSS.horizontalClearance,
    boxSizing: 'border-box',
  },
} as const;
